<template src="./Services.html">
</template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("lookups/getLookups");

        this.$store
            .dispatch("doctors/getDoctorServiceRates", this.itemId)
            .then((res) => {
                this.request = res

            })
            .catch(() => { });
    },
    data() {
        return {
            vm: {
                procedureId: null,
                commissionRate: null,
                operatingExpenseRatio: null,
            },
            indexItem: null,
            editFlag: false,
            request: {
                id: null,
                fullName: null,
                procedures: [],
            },
            headers: [
                { text: 'تصنيف الخدمة', value: 'procedureId' },
                { text: "النسبة", value: 'commissionRate' },
                { text: "نسبة المصاريف التشغيلية", value: 'operatingExpenseRatio' },
                { text: 'الاجراءات', value: 'actions', sortable: false },

            ],

        };
    },
    computed: {

        procedures() {
            return [
                ...this.$store.getters["lookups/getLookupByType"](
                    this.$lookupTypes.ProcedureTypes
                )];
        },
    },
    methods: {
        ChangePaymentType() {
            this.vm.fixedSalary = null;
            this.vm.commissionRate = null;
        },
        confirm() {
            this.$store
                .dispatch("doctors/serviceManagement",{ id : this.itemId,payload:this.request})
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },

        back() {
            this.$emit("back");
        },
        // ---------------------------------------------//
        AddItem() {
            if (this.vm.procedureId == null || this.vm.commissionRate == null || this.vm.operatingExpenseRatio == null) {
                showAlert(`يجب التحقق من تعبئة البيانات  `);
                return false;
            }
            var Index = this.request.procedures.findIndex(x => x.procedureId == this.vm.procedureId);
            if (Index != -1) {
                showAlert(`لا يمكن اضافة نفس الخدمة اكثر من مرة   `);
                return false;
            }
            this.request.procedures.push({
                procedureId: this.vm.procedureId,
                commissionRate: this.vm.commissionRate,
                operatingExpenseRatio: this.vm.operatingExpenseRatio,
            });
            this.vm.procedureId = null;
            this.vm.commissionRate = null;
            this.vm.operatingExpenseRatio = null;
            //this.$refs.info.reset();
        },
        updateItem() {
            if (this.vm.procedureId == null || this.vm.commissionRate == null || this.vm.operatingExpenseRatio == null) {
                showAlert(`يجب التحقق من تعبئة البيانات  `);
                return false;
            }
            var Index = this.request.procedures.findIndex(x => x.procedureId == this.vm.procedureId);
            if (Index == -1) {
                showAlert(`حدث خطأ اثناء عملية التعديل`);
                return false;
            }
            console.log(this.vm)
  this.request.procedures.splice(this.indexItem, 1, {
        procedureId: this.vm.procedureId,
        commissionRate: this.vm.commissionRate,
        operatingExpenseRatio: this.vm.operatingExpenseRatio,
    });

console.log( this.request.procedures);
            this.vm.procedureId = null;
            this.vm.commissionRate = null;
            this.vm.operatingExpenseRatio = null;
            //this.$refs.info.reset();
        },
        getForEdit(item, index) {
          this.vm = {
        procedureId: item.procedureId,
        commissionRate: item.commissionRate,
        operatingExpenseRatio: item.operatingExpenseRatio,
    };
            console.log(item)
            console.log(this.vm)
            this.indexItem = index;
            this.editFlag = true;
        },
        removeItem(index) {
            this.request.procedures.splice(index, 1);
        },
    },
};
</script>